export const HTTP_STATE_FETCH_STATUS = 'HTTP_STATE_FETCH_STATUS'
export const HTTP_STATE_FETCH_ERROR_MESSAGE = 'HTTP_STATE_FETCH_ERROR_MESSAGE'